import React from "react";

// Extrait de Create.tsx (composant local à l'origine) pour être réutilisable ailleurs — d'abord
// par FastCreateSheet.tsx, qui n'a besoin que de deux options (public/amis, jamais "sur
// invitation" qui n'a pas de sens pour une rencontre spontanée). `options` est désormais
// obligatoire plutôt que par défaut sur la liste 3 options de Create.tsx, pour ne pas coupler
// ce composant partagé à des constantes propres à une seule page.
// `icon` optionnel : Create.tsx n'en a jamais eu besoin (3 options en texte seul), mais
// FastCreateSheet en a besoin pour remplacer les emoji 🌍/👥 par de vraies icônes SVG — plutôt
// que les coder en dur dans le label comme avant.
export type AudienceOption = { key: string; label: string; sub: string; icon?: React.ComponentType<{ color?: string; size?: number }> };

export default function AudienceSelector({ value, onChange, options }: { value: string; onChange: (v: string) => void; options: AudienceOption[] }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
      {options.map(aud => {
        const Icon = aud.icon;
        const active = value === aud.key;
        return (
          <div key={aud.key} onClick={() => onChange(aud.key)} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 12, border: `1px solid ${active ? "#0a0a0a" : "#E0E0E0"}`, backgroundColor: active ? "#0a0a0a" : "white", cursor: "pointer" }}>
            {Icon && <Icon color={active ? "white" : "#0a0a0a"} size={18} />}
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: active ? "white" : "#0a0a0a" }}>{aud.label}</div>
              <div style={{ fontSize: 11, color: active ? "rgba(255,255,255,0.6)" : "#999", marginTop: 2 }}>{aud.sub}</div>
            </div>
            {active && <span style={{ color: "white", fontSize: 16 }}>✓</span>}
          </div>
        );
      })}
    </div>
  );
}
